import { EmailTemplates } from "./BackendTypes"
import Contract from "./Contract"
import { FBDate, InterestRate } from "./Globals"
import { KnowledgeTest } from "./InvestmentKnowledge"
import { AccountId, InvestorId } from "./Investor"
import { ProjectId } from "./Project"


export enum InvestmentStep {
    InvestmentAmountStep = "InvestmentAmountStep",
    KYCDataStep = "KYCDataStep",
    AcceptTerms = "AcceptTerms",
    InvestorTest = "InvestorTest",
    Contract = "Contract",
    Transfer = "Transfer",
    Congratulations = "Congratulations",
    InvestmentDetails = "InvestmentDetails",
    InvestmentCanceled = "InvestmentCanceled"
}


export type InvestmentId = string

export type Investment = {
    investmentId: InvestmentId;
    investorId: InvestorId;
    investorAccountId: AccountId;
    projectId: ProjectId;
    amount: number;
    investmentTerms: InvestmentTerms;
    step: InvestmentStep;
    cancelData?: InvestmentCancelData;
    followUpData?: InvestmentFollowUpData;
    customPaidBackAmount?: number
}

export type InvestmentTerms = {
    interestRate: InterestRate;
    created: FBDate;
    contracts: Contract[];
}

export type NewInvestmentProps = {
    projectId: ProjectId;
}

export type InvestmentAmountProps = {
    amount: number;
}

export type InvestmentAccountProps = {
    accountId: AccountId;
}

export type InvestmentKnowledgeTestProps = {
    knowledgeTest?: KnowledgeTest;
}

export type InvestmentStepProps = {
    newStep: InvestmentStep;
}

export type InvestmentCancelData = {
    canceledBy: string;
    canceledDate: string;
    cancelReason: string;
}

export type InvestmentFollowUpData = {
    plannedDate: FBDate;
    emailTemplate: EmailTemplates
}

export default Investment
